module.exports = __webpack_public_path__ + "static/img/car6.9423331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car6.png
// module id = dnvN
// module chunks = 1